export default {
    title: 'Update',
    info: 'Note: There are changes since the last publication of the trend radar',
    button: 'Update'
}
